var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("image-" + _vm.wrapperStyle + "-width-" + _vm.size)},[(_vm.urlIsValid || _vm.forceImageShow)?_c('img',{attrs:{"src":_vm.imageUrl}}):_c('p',[_vm._v(_vm._s(_vm.nameInitials))])])}
var staticRenderFns = []

export { render, staticRenderFns }